export const togetherShow = {
  type: 'screen',
  color: '#2d61e2',
  bgcolor: '#22293a',
  eventType: {
    ru: 'Online event'
  },
  title: {
    ru: 'Вместе SHOW'
  },
  link: 'together-show',
  page: {
    image: '00-main-photo-min.jpg',
    meta: {
      date: {
        ru: 'июль 2020',
        en: 'JULY 2020'
      },
      location: {
        ru: 'Россия',
        en: 'RUSSIA'
      },
      events: [],
      tags: []
    },
    intro: {
      ru: 'Как создать онлайн-мероприятие, которое привлечёт аудиторию эффективнее офлайна?',
      en: 'Как создать онлайн-мероприятие, которое привлечёт аудиторию эффективнее офлайна?'
    },
    video: 'https://www.youtube.com/embed/3Iscboxwt1s?autoplay=0',
    videoImage: null,
    gallery: {
      small: ['14.jpg', '15.jpg'],
      large: ['17.jpg']
    },
    gallery2: {
      small: ['19.jpg', '18.jpg'],
      large: ['1010_small.jpg']
    },
    gallery3: {
      small: [],
      large: ['99.jpg']
    },
    gradient: 'linear-gradient(150deg,#2d61e2,#267dc0)',
    content: {
      image: 'event.png',
      text: {
        ru: '<p class="ru">Лето-2020 запомнится в event-индустрии как эпоха онлайн-мероприятий. Смена жанра была обусловлена объективными обстоятельствами, но, создавая проект «Вместе шоу», мы старались подчеркнуть, что это не просто вынужденный формат, а high-concept event, который мог быть уместен и оправдан, даже если бы в мире не было никаких ограничений.</p>',
        en: '<p class="en">Лето-2020 запомнится в event-индустрии как эпоха онлайн-мероприятий. Смена жанра была обусловлена объективными обстоятельствами, но, создавая проект «Вместе шоу», мы старались подчеркнуть, что это не просто вынужденный формат, а high-concept event, который мог быть уместен и оправдан, даже если бы в мире не было никаких ограничений.</p>',
        fz: '23'
      }
    },
    content2: {
      title: '<p class="ru">Команда Panda Project всего за месяц придумала телевизионное шоу специально для Газпромбанка.</p><p class="en">Команда Panda Project всего за месяц придумала телевизионное шоу специально для Газпромбанка.</p>',
      fzTitle: '31',
      text: '<p class="ru">«Вместе шоу» - это прецедент для бренда. Впервые в мероприятии банка участвовала вся страна, общаясь друг с другом, делясь эмоциями, и это происходит не постфактум через опросы, а "здесь и сейчас"– с помощью интерактивных функций, чатов и вовлеченности не только во время, но и при подготовке эфира.</p><p class="en">«Вместе шоу» - это прецедент для бренда. Впервые в мероприятии банка участвовала вся страна, общаясь друг с другом, делясь эмоциями, и это происходит не постфактум через опросы, а "здесь и сейчас"– с помощью интерактивных функций, чатов и вовлеченности не только во время, но и при подготовке эфира.</p>',
      fzText: '21'
    },
    content3: {
      left: '<p class="ru">– 16 300 просмотров во время прямого эфира</p><p class="en">– 16 300 просмотров во время прямого эфира</p><p class="ru">– 504 комментария в онлайн-чате</p><p class="en">– 504 комментария в онлайн-чате</p><p class="ru">– 312 фотографий прислано в эфир</p><p class="en">– 312 фотографий прислано в эфир</p><p class="ru">– 3,5 часа эфира нон-стоп </p><p class="en">– 3,5 часа эфира нон-стоп </p><p class="ru">– Съемка контента в 21 городе</p><p class="en">– Съемка контента в 21 городе</p><p class="ru">– Более 100 человек в съемочной группе</p><p class="en">– Более 100 человек в съемочной группе</p><p class="ru">– 5 недель на реализацию проекта с нуля</p><p class="en">– 5 недель на реализацию проекта с нуля</p><p class="ru">– 72 часа монтажных работ</p><p class="en">– 72 часа монтажных работ</p><p class="block-line block-line-bottom"></p>',
      fzLeft: '19',
      right: '<p class="txt text-normal ru"><b class="text-normal">“Вместе show” - это своего рода внутренняя видеопрезентация бренда, что делает мероприятие не только развлекательным, но и сверхэффективным с точки зрения решений HR-задач.</b></p><p class="txt text-normal en"><b class="text-normal">“Вместе show” - это своего рода внутренняя видеопрезентация бренда, что делает мероприятие не только развлекательным, но и сверхэффективным с точки зрения решений HR-задач.<b></p><p class="ru">Почти 4-часовой эфир превратился в шоу уровня топ-каналов. В нем были сбалансированы элементы ток-шоу и выступления звезд:  Полины Гагариной, Леонида Агутина, группы «Руки Вверх!», Павла Воли, Фёдора Бондарчука, Евгения Гришковца, Дениса Мацуева и многих других. Кроме того, в эфире постоянно появлялся визуальный контент, показывающий, чем живет банк: арт-проекты, перформансы, ребрендинг через ценности, заложенные в искусство, музыку, поэзию.</p><p class="en">Почти 4-часовой эфир превратился в шоу уровня топ-каналов. В нем были сбалансированы элементы ток-шоу и выступления звезд:  Полины Гагариной, Леонида Агутина, группы «Руки Вверх!», Павла Воли, Фёдора Бондарчука, Евгения Гришковца, Дениса Мацуева и многих других. Кроме того, в эфире постоянно появлялся визуальный контент, показывающий, чем живет банк: арт-проекты, перформансы, ребрендинг через ценности, заложенные в искусство, музыку, поэзию.</p>',
      fzRight: '19'
    }
  }
}
